import Heading from 'LearningManager/components/Heading';
import styles from 'LearningManager/styles/CustomSetup.module.scss';
import CheckBoxCard from 'LearningManager/components/CheckBoxCard';
import { Icon, Input } from 'Components';
import MultiSelectDropdown from 'LearningManager/components/MultiSelectDropdown';
import { useStepper } from 'LearningManager/hooks/Stepper.context';

interface optionsProps {
	id: number;
	title: string;
	desc: string;
}

const options: optionsProps[] = [
	{
		id: 1,
		title: 'Guest Relations',
		desc: '300 users'
	},
	{
		id: 2,
		title: 'Room Service Management',
		desc: '150 users'
	},
	{
		id: 3,
		title: 'Event Coordination',
		desc: '200 users'
	},
	{
		id: 4,
		title: 'Front Desk Operations',
		desc: '400 users'
	},
	{
		id: 5,
		title: 'Facility Maintenance',
		desc: '220 users'
	},
	{
		id: 6,
		title: 'Culinary Services',
		desc: '180 users'
	},
	{
		id: 7,
		title: 'Luxury Experience Coordination',
		desc: '275 users'
	},
	{
		id: 8,
		title: 'Sales Promotions',
		desc: '350 users'
	}
];

const Group = () => {
	const {
		draft: {
			customSetup: { selectedGroupIds, selectedGroupPropertyIds }
		},
		toggleAssignUsersSelection,
		setAssignUsersSelection,
		setAssignUsersPropertyFilter
	} = useStepper();

	const handleCheckboxChange = (id: number, checked: boolean) => {
		if (checked !== selectedGroupIds.includes(id)) {
			toggleAssignUsersSelection('selectedGroupIds', id);
		}
	};

	const handleSelectAll = () => {
		if (selectedGroupIds.length === options.length) {
			setAssignUsersSelection('selectedGroupIds', []);
		} else {
			setAssignUsersSelection(
				'selectedGroupIds',
				options.map((opt) => opt.id)
			);
		}
	};

	const properties = [
		{ id: 1, label: 'Pyramid Hotel' },
		{ id: 2, label: 'Marriott Hotel' },
		{ id: 3, label: 'Grand Plaza' },
		{ id: 4, label: 'Ocean View Resort' }
	];

	const handleChange = (ids: number[]) => {
		setAssignUsersPropertyFilter('selectedGroupPropertyIds', ids);
	};

	const isAllSelected = selectedGroupIds.length === options.length;

	return (
		<div>
			<div>
				<Heading />
				<div className={styles.filters}>
					<div className={styles.search}>
						<div className={styles.selectProp}>Select Property</div>
						<MultiSelectDropdown
							options={properties}
							placeholder="Select option"
							onChange={handleChange}
							defaultSelectedIds={selectedGroupPropertyIds}
						/>
					</div>
					<Input.Search
						className={styles.search}
						placeholder="Search"
						suffix={<Icon type="search" role="img" />}
					/>
				</div>
			</div>
			<div className={styles.header}>
				<Heading
					titleClassName={styles.title}
					title="Select properties"
					astrix={true}
				/>
				{options.length > 1 && (
					<div
						className={styles.selectAllBtn}
						onClick={handleSelectAll}
					>
						{isAllSelected ? 'Deselect all' : 'Select all'}
					</div>
				)}
			</div>
			<div className={styles.container}>
				{options.map((option) => (
					<CheckBoxCard
						key={option.id}
						id={option.id}
						icon={<Icon type="groupOptIcon" />}
						title={option.title}
						desc={option.desc}
						isChecked={selectedGroupIds.includes(option.id)}
						onChange={handleCheckboxChange}
					/>
				))}
			</div>
		</div>
	);
};

export default Group;
